<template>
    <div class="orderTab-bottom">
        <app-custom-time v-if="customTime" @changeTime="transactionListing()"></app-custom-time>
        <div class="topMazimize d-flex align-items-center border-bottom justify-content-between" v-if="$route.name == 'custom-view'">
            <p>{{$t('trade_logs')}}</p>
            <div class="justify-content-end">
                <a href="#" @click.prevent="$parent.$parent.maximize('trade_log')"><feather size="12px" type="maximize-2"></feather></a>
                <a href="#" @click.prevent="$parent.$parent.close('trade_log')"><feather size="12px" type="x"></feather></a>
            </div>
        </div>
        <div class="topHead border-bottom d-flex justify-content-between align-items-center">
            <tab-section :order="order"/>
            <div class="arrowToggle d-flex align-items-center">
                <div class="filterOption position-relative d-flex align-items-center">
                    <div class="custonDropDown dropdown-menu show" v-if="filterOption && customTime == false">
                        <ul>
                            <li v-for="list,key in dateList" class="p-0">
                                <label class="customRadiobox">{{list}}
                                    <input type="radio" name="radio" :value="key" v-model="dateSelected" @change="changeDate()">
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                            <li class="customTime-btn customTime p-0">
                                <a @click.prevent="customTime = !customTime" href="javascript:void(0)" class="customTime">{{$t('custom')}}</a> 
                            </li>
                        </ul>
                    </div>
                    <button type="button" title="Date Range" class="appButton-r filterOption d-flex align-items-center justify-content-between" @click.prevent="filterOption = !filterOption"><feather size="15px" type="filter"></feather></button>
                </div>
                <button type="button" title="Maximize / Collapse" class="appButton-r d-flex align-items-center justify-content-between ml-2" @click="addRemBodyClass()" v-if="$route.name == 'home'">
                    <feather class="showMin" size="15px" type="maximize-2"></feather>
                    <feather class="showMax d-none" size="15px" type="minimize-2"></feather>
                </button>
                <pagination :totalRecords="transactionHistory.length" :limit="pageLimit" :pageNo="page" :showRecords="false" v-if="order == 'transition-history' && transactionHistory.length > pageLimit"></pagination>
                <a @click="$parent.$parent.setUpFxaccount = !$parent.$parent.setUpFxaccount" class="arrowToggle-buton ml-3" href="#" v-if="$route.name == 'multi-view'"><feather size="15px" type="chevron-up"></feather> </a>
            </div>
        </div>
        <div class="responsiveTable scrollbar bottomTable fixedHead" v-if="order == 'transition-history'">
            <table class="table stickyHead">
                <thead class="border-0" v-if="transactionHistory.length > 0">
                    <tr>
                        <th>{{$t('open_date_time')}}</th>
                        <th>{{$t('transaction_ID')}}</th>
                        <th>{{$t('type')}}</th>
                        <th>{{$t('amount')}}</th>
                        <!-- <th>Mode</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="list,index in transactionHistory" v-if="index >= (page - 1)*pageLimit && index < page*pageLimit && list.TRANSACTION_TYPE !='RELEASE_BONUS'">
                        <td>{{dateFormat(list.TRANSACTION_DATE)}}</td>
                        <td>{{list.TRANSACTION_ID}}</td>
                        <td>{{logType(list)}}</td>
                        <td>{{(list.AMOUNT < 0)?'-':''}}{{currencyIcon[list.ACCOUNT_CURRENCY]}}{{Math.abs(list.AMOUNT)}}</td>
                        <!-- <td>{{list.COMMENTARY}}</td> -->
                    </tr>
                    <tr v-if="transactionHistory.length == 0">
                        <td class="noData border-0 h-100">
                            <app-loader v-if="pageLoader"/>
                            <no-data v-else text="No Transactions"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import app_custom_time from './app-custom-time'
import tab_section from './tab-section'
import { commonAllmixins } from '@/plugins/commonAll'
import moment from 'moment'
export default {
    name: 'trade-log',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader: false,
            page : '1',
            currencyIcon : { EUR : "€", USD : "$", GBP : "£", CHF : "CHF", JPY : "¥", AUD: "$" },
            FROM_DATE : moment().subtract(6, 'months').format('YYYY-MM-DD'),
            // FROM_DATE : moment(new Date(Date.now() - 30*24 * 3600 * 1000)).format('YYYY-MM-DD'),
            TO_DATE : moment(Date.now()).format('YYYY-MM-DD'),
            filterOption: false,
            customTime: false,
            dateSelected:'',
            dateList:{ '1':'1 day', '2':'15 days', '3':'1 Month', '4':'6 Months' },
        }
    },
    components:{
        appCustomTime:app_custom_time,
        tabSection:tab_section
    },
    props:{
        pageLimit:{
            type: Number,
            default: 5
        },
        order:{
            default: 'transition-history'
        }
    },
    methods:{
        addRemBodyClass(){
            if($(document.getElementsByClassName('maxCollapse')).hasClass('maximizeToggle')){
                $(document.getElementsByClassName('maxCollapse')).removeClass('maximizeToggle')

                $(document.getElementsByClassName('splitTop')).height('calc(100vh - 290px)')

                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 5
                }
            }else{
                $(document.getElementsByClassName('maxCollapse')).addClass('maximizeToggle')
                $(document.getElementsByClassName('splitTop')).height(0)
                if(this.$route.name == 'home'){
                    this.$parent.pageLimit = 15
                }
            }
        },
        logType(list){
            if(list.TRANSACTION_TYPE == 'DEPOSIT_WITHDRAW'){
                return (list.AMOUNT > 0)?'DEPOSIT':'WITHDRAW'
            }else{
                return list.TRANSACTION_TYPE.split('_').join(' ')
            }
        },
        changeDate(){
            this.filterOption = false
            if(this.dateSelected == '1'){
                this.FROM_DATE = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(this.dateSelected == '2'){
                this.FROM_DATE = moment().subtract(15, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(this.dateSelected == '3'){
                this.FROM_DATE = moment().subtract(1, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(this.dateSelected == '4'){
                this.FROM_DATE = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }
            this.transactionListing()
        },
        settingsDate(){
            let history_range = this.userSettings.history_range || ''
            this.filterOption = false
            if(history_range == '1'){
                this.FROM_DATE = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(history_range == '2'){
                this.FROM_DATE = moment().subtract(15, 'days').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(history_range == '3'){
                this.FROM_DATE = moment().subtract(1, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }else if(history_range == '4'){
                this.FROM_DATE = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.TO_DATE = moment().format('YYYY-MM-DD');
            }
            this.dateSelected = history_range
        },
        transactionListing(){
            this.customTime = false
            this.dateSelected = ''
            let inputJson = {
                'globalParams' : {
                    'FROM_DATE' : this.FROM_DATE,
                    'TO_DATE' : this.TO_DATE ,
                },
                'localParams' : { 'parameter' : this }
            }
            this._runGetTransactionHistory(inputJson)
        },
        dateFormat(val){
            let date = '';
            try{
                date += val.slice(0, 4) //YYYY
                date += "-"+val.slice(4, 6) //MM
                date += "-"+val.slice(6, 8) //DD
                // date += "T"+val.slice(8, 10) //HH
                date += val.slice(8, 10) //HH
                date +=":"+val.slice(10, 12) //mm
                date +=":"+val.slice(12, 14) //ss
            }catch(e){}
            // let d = new Date(date);
            // return moment(d).format('HH:mm:ss - DD-MM-YYYY')
            return this.formatDateTime(date)
        },
    },
    created(){
        if(this.transactionHistory.length == 0){
            this.transactionListing()
        }
    },
    mounted() {
        this.settingsDate()
        const _that = this
        $(document).on("click", function(event){
            if(!$(event.target).closest('.customTime').length){
                _that.customTime = false
            }
            if(!$(event.target).closest('.filterOption').length){
                _that.filterOption = false
            }
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/order/trade-logs.vue